<template>
  <div class="tw-relative">
    <BaseTopLine> </BaseTopLine>

    <div v-if="isShowBanner" class="tw-bg-bgPage tw-pb-[20px]">
      <div class="tw-flex tw-justify-center tw-px-[26px] tw-bg-gradient-to-r tw-from-[#ECF3FE] tw-to-[#ECF3FE]">
        <div class="tw-max-w-[1290px] tw-mx-auto">
          <img
            :src="require(`@/assets/images/708_banner2.webp`)"
            class="tw-w-[100%]"
          />
        </div>
      </div>
    </div>

    <div class="tw-relative tw-mb-[15px]">
      <vue-tabs
        v-model="activateTab"
        @tab-change="
          () => {
            resetFilter();
          }
        "
        class="vue-tabs-type-1"
      >
        <v-tab :title="dataLang['tracker_text13']" />
        <v-tab :title="dataLang['tracker_text14']" />
      </vue-tabs>
    </div>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div
        v-if="aboutPageInfo"
        class="tw-flex tw-justify-between tw-items-center tw-pb-[10px] tw-mb-[15px] tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#E7EAF2] tw-text-white"
      >
        <div
          v-html="
            computedTranslate(
              {
                companies__gelios_tariff:
                  aboutPageInfo.data.companies__gelios_tariff,
              },
              dataLang['tracker_text93']
            )
          "
        ></div>

        <div class="tw-flex tw-items-center tw-gap-[10px]">
          <div>
            GPS счет:
            <span class="tw-font-semibold">
              {{ aboutPageInfo.data.companies__gelios_balance }} руб
            </span>
          </div>
          <button class="tw-app-btn-warning" @click="$modal.show('addBalance')">
            {{ dataLang["tracker_text16"] }}
          </button>
        </div>

        <div class="tw-flex tw-items-center tw-gap-[10px]">
          <div class="tw-flex tw-items-center tw-gap-[3px]">
            Автопополнение
            <img
              @click="
                $modal.show('questionModal', {
                  text: 'Автопополнение GPS счета с баланса нужно, чтобы Сириус не отключил все ваши трекеры, если GPS счет достигнет “0”. Как это работает: включите автополнение и Сириус сам пополнит с баланса ваш GPS счет, когда он снизится ниже 1000 рублей. Сумма пополнения расчитывается так: количество включенных объектов * стоимость 30 суток. Если у вас включены 1 или 2 трекера, Сириус пополнит ваш GPS счет несколько раз, пока он не превысит 1000 р.',
                })
              "
              :src="require(`@/assets/icons/question-white.svg`)"
              class="tw-cursor-pointer tw-mb-[12px]"
              width="14"
              height="15"
            />
          </div>
          <label class="form-switch form-switch--custom ps-0">
            <input
              type="checkbox"
              :checked="
                !globalSettings.company_settings__is_allow_auto_send_money_to_gelios_balance
              "
              @input="
                (e) => {
                  globalSettings.company_settings__is_allow_auto_send_money_to_gelios_balance =
                    !e.target.checked;
                  updateGlobalSetting(
                    !e.target.checked,
                    'company_settings__is_allow_auto_send_money_to_gelios_balance'
                  );
                }
              "
            />
            <i></i>
          </label>
          <div
            v-if="
              !!globalSettings.company_settings__is_allow_auto_send_money_to_gelios_balance
            "
          >
            Вкл
          </div>
          <div v-else>Выкл</div>
        </div>
      </div>

      <div class="tw-flex tw-justify-between tw-gap-[20px] tw-text-white">
        <div class="tw-flex tw-items-end tw-gap-[10px]">
          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["tracker_text2"] }}</label
            >
            <BaseInputNew
              @keyupEnter="loadData()"
              inputClass="tw-app-input-dark"
              @input="
                fillFilter($event),
                  (filters.gps__tracker_id.value = $event.value)
              "
              :additionalParams="{ type: 'like' }"
              inputName="gps__tracker_id"
              :value="filters.gps__tracker_id.value"
            />
          </div>

          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["tracker_text3"] }}</label
            >
            <BaseInputNew
              @keyupEnter="loadData()"
              inputClass="tw-app-input-dark"
              @input="
                fillFilter($event), (filters.gps__imei.value = $event.value)
              "
              :additionalParams="{ type: 'like' }"
              inputName="gps__imei"
              :value="filters.gps__imei.value"
            />
          </div>

          <div class="tw-app-input-container">
            <label class="tw-app-input-container-label">
              {{ dataLang["tracker_text4"] }}</label
            >
            <BaseInputNew
              @keyupEnter="loadData()"
              inputClass="tw-app-input-dark"
              @input="
                fillFilter($event),
                  (filters.vehicles__gosnumber.value = $event.value)
              "
              :additionalParams="{ type: 'like' }"
              inputName="vehicles__gosnumber"
              :value="filters.vehicles__gosnumber.value"
            />
          </div>

          <div class="tw-flex tw-flex-row">
            <button @click="loadData(1)" class="tw-app-btn-primary">
              {{ dataLang["tracker_text1"] }}
            </button>
          </div>
        </div>

        <div class="tw-flex tw-items-end tw-gap-[10px]">
          <button
            class="tw-app-btn-primary"
            @click="
              () => {
                resetFilter();
                fillFilter({
                  name: 'gps__vehicle_id',
                  value: '',
                  mod: 'isNull',
                });
                loadData(1);
              }
            "
          >
            {{ dataLang["tracker_text6"] }}
          </button>
          <button
            class="tw-app-btn-primary"
            @click="
              () => {
                resetFilter();
                fillFilter({
                  name: 'gps__vehicle_id',
                  value: '',
                  mod: 'isNotNull',
                });
                loadData(1);
              }
            "
          >
            {{ dataLang["tracker_text5"] }}
          </button>
        </div>
      </div>
    </div>

    <div
      class="position-relative tw-px-[26px] tw-py-[15px]"
      style="min-height: 250px"
    >
      <BaseLoader v-if="localLoading"></BaseLoader>

      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-gap-[10px]">
          <button
            class="tw-app-btn-primary-outline"
            @click="
              () =>
                activeSelectRowsMultiple.length
                  ? $modal.show('acceptToggleTracker')
                  : $modal.show('selectRow')
            "
            v-html="
              activateTab == dataLang['tracker_text13']
                ? dataLang['tracker_text7']
                : dataLang['tracker_text8']
            "
          ></button>
          <button
            class="tw-app-btn-primary-outline"
            @click="
              () =>
                activeSelectRowsMultiple.length
                  ? $modal.show('acceptDeleteModal')
                  : $modal.show('selectRow')
            "
          >
            <img
              :src="require(`@/assets/icons/adddel.svg`)"
              width="13.5"
              height="13.5"
            />
            {{ dataLang["tracker_text9"] }}
          </button>

          <a
            href="https://docs.google.com/spreadsheets/d/1vkZuc5tkFOzLz65n0fcsKZFy8zkNlbo9sCM5zfpq6f8/edit#gid=1624217125"
            target="_blank"
            class="tw-app-btn-external !tw-inline-flex"
          >
            {{ dataLang["tracker_text10"] }}
          </a>
          <button
            class="tw-app-btn-external"
            v-if="!hasGeliosAccount"
            @click="toLoadGelios"
          >
            {{ dataLang["reg_fin_text_154"] }}
          </button>
          <button class="tw-app-btn-external" @click="toGeliosMap">
            Открыть карту
          </button>
          <button
            class="tw-app-btn-external"
            @click="$modal.show('mobileAppModal')"
          >
            Моб. приложение
          </button>
        </div>

        <div class="tw-flex tw-gap-[10px]">
          <div class="tw-app-btn-primary" @click="$modal.show('buyTracker')">
            {{ dataLang["tracker_text11"] }}
          </div>
          <div
            class="tw-app-btn-primary"
            @click="$modal.show('buyTranslateTracker')"
          >
            {{ dataLang["tracker_text12"] }}
          </div>
        </div>
      </div>

      <div
        class="mb-10 d-flex justify-content-between align-items-center mt-15"
      >
        <div></div>
        <!-- <div class="d-flex gap-15 align-items-center">
          <div
            class="text-white btn btn-sm btn-thrity fsc-14"
            @click="loadData(1)"
          >
            {{ dataLang["register_btn_filter_on"] }}
          </div>
          <div
            class="text-decoration-underline fsc-14 text-dark"
            style="cursor: pointer"
            @click="resetFilter"
          >
            {{ dataLang["register_btn_filter_off"] }}
          </div>
        </div> -->
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationFinesStateParams,
            limit: limitPaginationValue,
          }"
          @updateLimitValue="updateLimitValue"
          :showLimitInput="true"
          :page-range="10"
          :margin-pages="0"
          :break-view-class="''"
          :click-handler="loadData"
          :prev-text="''"
          :next-text="''"
        >
        </TwBasePagination>
      </div>
      <div class="overflow-auto_" style="min-height: 400px">
        <ve-table
          class="fixed-header rest-style-table"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="gps__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="acceptToggleTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader
          v-if="isLoadingFinishModal"
          class="tw-rounded-[25px]"
        ></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptToggleTracker')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            <span v-if="activateTab == dataLang['tracker_text13']">
              Выключить выбранные трекеры?
            </span>
            <span v-if="activateTab == dataLang['tracker_text14']">
              Включить выбранные трекеры?
            </span>
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptToggleTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text50"] }}
            </button>
            <button
              @click="toggleTrackerHandler"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptDeleteModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDeleteModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text61"] }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDeleteModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="deleteAcceptRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="selectRow"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div
        class="tw-app-modal__container tw-flex tw-justify-center tw-items-center"
      >
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('selectRow')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title tw-max-w-[300px]">
            {{ dataLang["tracker_text57"] }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('selectRow')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="buyTracker"
      width="420"
      :clickToClose="false"
      @before-close=""
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('buyTracker')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text65"] }}
          </div>

          <div>
            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <div class="tw-text-[14px] tw-text-forText">
                {{ dataLang["tracker_text66"] }}
              </div>
              <BaseInputNew
                class="tw-w-full"
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__sim_phone"
                :horizontalTitle="true"
                @input="
                  ({ value }) => {
                    newValueCustomModal = value;
                  }
                "
              >
              </BaseInputNew>
            </div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('buyTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text50"] }}
            </button>
            <button
              @click="onBuyTracker"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text69"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="buyTranslateTracker"
      width="420"
      :clickToClose="false"
      @before-close=""
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('buyTranslateTracker')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text68"] }}
          </div>

          <div>
            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <div class="tw-text-[14px] tw-text-forText">
                {{ dataLang["tracker_text66"] }}
              </div>
              <BaseInputNew
                class="tw-w-full"
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__sim_phone"
                :horizontalTitle="true"
                @input="
                  ({ value }) => {
                    newValueCustomModal = value;
                  }
                "
              >
              </BaseInputNew>
            </div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('buyTranslateTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text50"] }}
            </button>
            <button
              @click="onBuyTranslateTracker"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text69"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorOfActivateTracker"
      width="420"
      :clickToClose="false"
      @before-close="() => (dataOfErrors = null)"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div
        class="tw-app-modal__container tw-flex tw-justify-center tw-items-center"
      >
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorOfActivateTracker')"
        ></button>

        <div class="tw-text-center">
          <div
            v-if="dataOfErrors"
            v-html="computedTranslate(dataOfErrors, dataLang['tracker_text81'])"
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorOfActivateTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successOfBuyTracker"
      width="420"
      :clickToClose="false"
      @before-close="() => (newValueCustomModal = '')"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successOfBuyTracker')"
        ></button>

        <div class="tw-text-center">
          <div
            class="tw-app-modal__title"
            v-html="dataLang['tracker_text70']"
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successOfBuyTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="addBalance"
      width="420"
      :clickToClose="false"
      @before-close=""
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('addBalance')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text86"] }}
          </div>

          <div>
            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <div class="tw-text-[14px] tw-text-forText tw-whitespace-nowrap">
                {{ dataLang["tracker_text87"] }}
              </div>
              <BaseInputNew
                class="tw-w-full"
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__sim_phone"
                :horizontalTitle="true"
                @input="
                  ({ value }) => {
                    newValueCustomModal = value;
                  }
                "
              >
              </BaseInputNew>
            </div>

            <!-- новый код для пополнения баланса с баллов -->
            <div v-if="false" class="text-[15px] tw-my-[30px]">
              Откуда пополнить?

              <BaseRadio
                class="tw-my-[10px] dark-before"
                signClass="!tw-text-[14px] !tw-text-forText"
                value="1"
              >
                С баланса (у вас 2257)
              </BaseRadio>
              <BaseRadio
                class="dark-before"
                signClass="!tw-text-[14px] !tw-text-forText"
                value="1"
              >
                Пополнить баллами (у вас 1568)
              </BaseRadio>

              <div class="tw-text-danger tw-text-left tw-text-[12px] tw-leading-[14px] tw-mt-[10px]">
                На балансе не хватает средств!<br />
                Пополните баланс (правый верхний угол) и повторите попытку!
              </div>
            </div>
            <!-- новый код для пополнения баланса с баллов -->
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('addBalance')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text50"] }}
            </button>
            <button
              @click="onAddBalance"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text88"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorOfAddBalance"
      width="420"
      :clickToClose="false"
      @before-close="() => (newValueCustomModal = '')"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorOfAddBalance')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text89']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorOfAddBalance')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <!-- <BaseModal
      name="errorOfAddBalance"
      width="420"
      :clickToClose="false"
      @before-close="() => (newValueCustomModal = '')"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="bg-transparent shadow-none"
    >
      <div class="pt-20 pb-20 bg-white rounded-25 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('errorOfAddBalance')"
          ></button>
        </div>
        <div class="pb-40 d-flex h-100 flex-column justify-content-center">
          <p class="mb-20 text-center" v-html="dataLang['tracker_text89']"></p>

          <div class="gap-10 d-flex justify-content-center">
            <div
              class="px-20 base-button base-button--action fsc-14 text-uppercase"
              @click="$modal.hide('errorOfAddBalance')"
            >
              {{ dataLang["tracker_text55"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal> -->

    <BaseModal
      name="successOfAddBalance"
      width="420"
      :clickToClose="false"
      @before-close="() => (newValueCustomModal = '')"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successOfAddBalance')"
        ></button>

        <div class="tw-text-center">
          <div
            v-html="
              computedTranslate(
                { count: newValueCustomModal },
                dataLang['tracker_text90']
              )
            "
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successOfAddBalance')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorOfBalance"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorOfBalance')"
        ></button>
        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text64']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorOfBalance')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successOfDisabledTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successOfDisabledTracker')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text83']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successOfDisabledTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successOfActivateTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="450"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successOfActivateTracker')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text82']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successOfActivateTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successAddTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successAddTracker')"
        ></button>

        <div>
          <div
            class="tw-app-modal__title"
            v-html="dataLang['tracker_text56']"
          ></div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successAddTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successDeleteTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successDeleteTracker')"
        ></button>

        <div class="tw-text-center">
          <div
            class="tw-app-modal__title"
            v-html="dataLang['tracker_text54']"
          ></div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successDeleteTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorDeleteTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorDeleteTracker')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text62']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorDeleteTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="editTracker"
      width="640"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @before-close="onCloseModal"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('editTracker')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text91"] }}
          </div>

          <div class="tw-text-[14px]">
            <div
              v-for="(item, index) in editTrackerData"
              class="tw-grid tw-grid-cols-[165px_auto]"
            >
              <div
                class="tw-border-0 tw-border-r-[1px] tw-border-solid tw-border-forLine"
              >
                <div class="tw-text-forText tw-py-[6px]">
                  {{ item.title }}
                </div>
              </div>
              <div class="tw-px-[10px] tw-py-[6px]">
                {{ item.value }}
              </div>
            </div>

            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text41"] }}
              </div>
              <div>
                <BaseSelect
                  class="multiselect-type-3"
                  @input="
                    (e) =>
                      updateValue({
                        value: e.vehicles__id,
                        name: 'gps__vehicle_id',
                      })
                  "
                  placeholder=""
                  selectLabel=""
                  deselectLabel=""
                  v-model="selectsFromModal.objectsVehicle"
                  :customLabel="
                    ({ vehicles__name, vehicles__gosnumber, vehicles__id }) => {
                      return vehicles__id
                        ? `${vehicles__name} ${vehicles__gosnumber}`
                        : vehicles__name;
                    }
                  "
                  :options="objectsVehiclesNew"
                  style="width: 415px"
                  :maxHeight="200"
                >
                  <template slot="noOptions">{{
                    dataLang["select_empty"]
                  }}</template>
                  <template slot="noResult">{{
                    dataLang["select_search_empty"]
                  }}</template>
                  <template slot="selectedLabel">{{
                    dataLang["select_selected"]
                  }}</template>
                  <template slot="deselectLabel">{{
                    dataLang["select_unselect"]
                  }}</template>
                </BaseSelect>
              </div>
            </div>

            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text107"] }}
              </div>
              <BaseSelect
                class="multiselect-type-3"
                :disabled="!!dataForModal.gps__gelios_unit_id"
                placeholder=""
                selectLabel=""
                deselectLabel=""
                v-model="selectsFromModal.volts"
                @input="(e) => updateValue({ value: e, name: 'gps__volt' })"
                :options="voltSelectOptions"
                style="width: 415px"
                :maxHeight="200"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template>
                <template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>

            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text42"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__sim_phone"
                :horizontalTitle="true"
                @input="updateValue"
                :value="dataForModal.gps__sim_phone"
                inputMask="+{7}(000)000-00-00"
                maxLength="16"
              >
              </BaseInputNew>
            </div>

            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text43"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__sim_operator"
                :horizontalTitle="true"
                @input="updateValue"
                :value="dataForModal.gps__sim_operator"
              >
              </BaseInputNew>
            </div>
            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text44"] }}
              </div>
              <BaseInputNew
                inputClass="tw-app-input-type-3"
                placeholder=""
                input-name="gps__canpr"
                :horizontalTitle="true"
                @input="updateValue"
                :value="dataForModal.gps__canpr"
              >
              </BaseInputNew>
            </div>

            <div
              class="tw-grid tw-grid-cols-[165px_auto] tw-items-center tw-my-[10px]"
            >
              <div class="tw-text-forText tw-py-[6px]">
                {{ dataLang["tracker_text45"] }}
              </div>
              <div>
                <BaseTextarea
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  :disabled="true"
                  @onInput="updateValue"
                  minHeight="54"
                  :maxLength="499"
                  :resize="false"
                  input-name="gps__comment_company"
                  :value="dataForModal.gps__comment_company"
                >
                </BaseTextarea>
              </div>
            </div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('editTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="saveEditModal"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text53"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="mobileAppModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @before-close="onCloseModal"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('mobileAppModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            Наблюдайте за своим парком <br />
            не только на Сириус, но и в <br />
            мобильном приложении Gelios!
          </div>

          <div
            v-if="!!Object.keys(geliosCredetials).length"
            class="tw-mt-[30px]"
          >
            <div>Ваши данные для входа:</div>
            <div class="tw-grid tw-grid-cols-[75px_auto]">
              <div>Логин:</div>
              <div class="tw-font-semibold">
                {{ geliosCredetials.company_settings__gelios_login }}
              </div>
            </div>
            <div class="tw-grid tw-grid-cols-[75px_auto]">
              <div>Пароль:</div>
              <div class="tw-font-semibold">
                {{ geliosCredetials.company_settings__gelios_password }}
              </div>
            </div>
          </div>

          <div class="tw-mt-[15px]">
            Наведите камеру смартфона для установки
          </div>

          <div
            class="tw-flex tw-justify-between tw-mt-[10px] tw-bg-[#F1F3F5] tw-rounded-[15px] tw-px-[10px] tw-pb-[10px]"
          >
            <div class="tw-flex tw-flex-col tw-text-center">
              <img
                width="165"
                height="165"
                :src="require(`@/assets/ios-qr.svg`)"
                alt=""
              />
              <div>iOS</div>
            </div>
            <div class="tw-flex tw-flex-col tw-text-center">
              <img
                width="165"
                height="165"
                :src="require(`@/assets/android-qr.svg`)"
                alt=""
              />
              <div>Android</div>
            </div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('mobileAppModal')"
              class="tw-app-btn-muted"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <QuestionModal />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import QuestionModal from "@/views/contracts-modal/QuestionModal.vue";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    QuestionModal,
  },

  data() {
    return {
      isShowBanner: undefined,
      limitPaginationValue: 50,
      filters: {
        gps__tracker_id: {
          value: null,
        },
        gps__imei: {
          value: null,
        },
        vehicles__gosnumber: {
          value: null,
        },
      },
      voltSelectOptions: [],
      hasGeliosAccount: false,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",
      settingOneClick: {},
      activePagePagination: {},
      newValueCustomModal: "",
      currentId: null,
      geliosCredetials: {},
      localLoadingModal: false,
      objectsVehiclesNew: [],
      isLoadingFinishModal: false,
      pincode: "",
      dataForModal: {},
      aboutPageInfo: null,
      fileLoadResult: null,
      dataOfErrors: null,
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        volts: null,
      },
      selectsData: {
        trackers: [],
        statuses: [],
        typeunits: [],
      },
      selectsFilter: {
        trackers: [],
        statuses: [],
        typeunits: [],
      },
      gelleryList: [],
      globalSettings: {
        company_settings__is_allow_auto_send_money_to_gelios_balance: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("editTracker");
              this.dataForModal = row;

              this.selectsFromModal.typeVehicles.push(
                this.selectsDataForModal.typeVehicles.find(
                  (value) =>
                    value.vehicle_types__id ==
                    this.dataForModal.vehicle_types__id
                ) || {
                  vehicle_types__code:
                    this.selectsDataForModal.typeVehicles[0]
                      .vehicle_types__code,
                  vehicle_types__id: null,
                }
              );
              if (this.dataForModal.vehicles__id) {
                this.selectsFromModal.objectsVehicle = [
                  {
                    vehicles__gosnumber: this.dataForModal.vehicles__gosnumber,
                    vehicles__id: this.dataForModal.vehicles__id,
                    vehicles__name: this.dataForModal.vehicles__name,
                  },
                ];
              } else {
                this.selectsFromModal.objectsVehicle = [
                  {
                    vehicles__gosnumber: "",
                    vehicles__id: null,
                    vehicles__name: "Не назначен",
                  },
                ];
              }
              this.selectsFromModal.volts = !this.dataForModal.gps__volt
                ? this.voltSelectOptions[0]
                : this.dataForModal.gps__volt;
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "companies__gelios_balance") {
            return row.settings?.companies__gelios_balance;
          }
        },
      },
    };
  },
  methods: {
    async toGeliosMap() {
      let answerAboutUrl = await GeneralService.get("/gelios/lk");
      window.open(answerAboutUrl.data.data.lk, "_blank");
    },
    updateGlobalSetting(data) {
      GeneralService.edit(`/settings`, {
        company_settings__is_allow_auto_send_money_to_gelios_balance: data,
      })
        .then((data) => {
          this.$toast.success("Успешно");
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.message, { duration: 5000 });
        });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      let name = data.name;
      let val =
        name === "gps__volt" && data.value === "не выбрано" ? null : data.value;
      this.updatedValues[name] = val;
    },

    toLoadGelios() {
      GeneralService.get(`/companies/register/gelios`)
        .then((data) => {
          this.$toast.success("Вы успешно зарегистрировались на Гелиос");
          this.hasGeliosAccount = true;
          window.location.href = window.location.href;
        })
        .catch((e) => {
          if (e?.response?.data?.message) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    async loadExel(urlToFetch) {
      let dataFrom = await httpInstance.get(urlToFetch, {
        responseType: "blob",
      });
      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    saveEditModal() {
      GeneralService.edit(`/trackers/${this.dataForModal.gps__id}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("editTracker");
          this.loadData();
        })
        .catch((e) => {
          this.selectsFromModal.owners = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    onBuyTracker() {
      if (this.newValueCustomModal) {
        GeneralService.editOrCreate(`/bids`, {
          request_services__type_service_id: 10,
          count: this.newValueCustomModal,
        })
          .then((data) => {
            this.$modal.hide("buyTracker");
            this.$modal.show("successOfBuyTracker");
            this.loadData();
          })
          .catch((e) => {
            this.$modal.hide("buyTracker");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      }
    },

    onBuyTranslateTracker() {
      if (this.newValueCustomModal) {
        GeneralService.editOrCreate(`/bids`, {
          request_services__type_service_id: 11,
          count: this.newValueCustomModal,
        })
          .then((data) => {
            this.$modal.hide("buyTranslateTracker");
            this.$modal.show("successOfBuyTracker");
            this.loadData();
          })
          .catch((e) => {
            this.$modal.hide("buyTranslateTracker");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      }
    },

    onAddBalance() {
      if (this.newValueCustomModal) {
        GeneralService.edit(`/trackers/balance`, {
          amount: this.newValueCustomModal,
        })
          .then((data) => {
            this.$modal.hide("addBalance");
            this.$modal.show("successOfAddBalance");
            this.loadData();
          })
          .catch((e) => {
            this.$modal.hide("addBalance");
            this.$modal.show("errorOfAddBalance");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      }
    },

    toggleTrackerHandler() {
      this.isLoadingFinishModal = true;
      GeneralService.edit(`/trackers/statuses/update`, {
        trackersIds: this.activeSelectRowsMultiple,
        active: this.activateTab == this.dataLang["tracker_text13"] ? 0 : 1,
      })
        .then((data) => {
          if (this.activateTab == this.dataLang["tracker_text13"]) {
            this.$modal.show("successOfDisabledTracker");
            this.activateTab = this.dataLang["tracker_text14"];
          } else {
            this.$modal.show("successOfActivateTracker");
            this.activateTab = this.dataLang["tracker_text13"];
          }
          this.resetFilter();
        })
        .catch((e) => {
          this.activeSelectRowsMultiple = [];
          if (e.response?.data?.errorCode == 10) {
            this.dataOfErrors = e.response.data.data;
            this.$modal.show("errorOfActivateTracker");
          }
          if (e.response?.data?.message) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        })
        .finally(() => {
          this.isLoadingFinishModal = false;
          this.$modal.hide("acceptToggleTracker");
        });
    },

    resetFilter() {
      Object.values(this.filters).forEach((filter) => (filter.value = null));
      // this.$refs.mainTable.$el
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      // this.$refs.topFilter
      //   .querySelectorAll("input.base-input--new")
      //   .forEach((elem, index) => {
      //     elem.value = "";
      //   });
      this.filter = [];
      this.selectsFilter.trackers = [];
      this.selectsFilter.statuses = [];
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    deleteAcceptRow() {
      GeneralService.delete(`/trackers/` + this.activeSelectRowsMultiple)
        .then((data) => {
          this.loadData();
          this.$modal.hide("acceptDeleteModal");
          this.$modal.show("successDeleteTracker");
        })
        .catch((e) => {
          this.$modal.hide("acceptDeleteModal");
          this.$modal.show("errorDeleteTracker");
        });
    },
    updateDataAboutPage() {
      GeneralService.get(`/trackers/page/info`)
        .then((data) => {
          this.hasGeliosAccount = data.data.data.hasGeliosAccount;
          this.aboutPageInfo = data.data;
        })
        .catch((e) => {});
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      this.updateDataAboutPage();
      Promise.all([
        GeneralService.get(`/objects/types`)
          .then((data) => {
            this.selectsDataForModal.typeVehicles = data.data.data.rows;
          })
          .catch((e) => {}),
        GeneralService.get(
          `/settings?fields=company_settings__gelios_login,company_settings__gelios_password`
        )
          .then((data) => {
            this.geliosCredetials = data.data.data.rows[0];
          })
          .catch((e) => {}),

        GeneralService.get(
          `/trackers/select/objects?where=[{"field":"vehicles__type_id", "value":"1"}]`
        )
          .then((data) => {
            this.objectsVehiclesNew = data.data.data.rows;
            this.objectsVehiclesNew.unshift({
              vehicles__name: "Не назначен",
              vehicles__id: null,
              vehicles__gosnomer: "",
            });
          })
          .catch((e) => {}),
        GeneralService.get(
          `/settings?fields=company_settings__is_allow_auto_send_money_to_gelios_balance`
        )
          .then((data) => {
            this.globalSettings.company_settings__is_allow_auto_send_money_to_gelios_balance =
              !!data.data.data.rows[0]
                .company_settings__is_allow_auto_send_money_to_gelios_balance;
          })
          .catch((e) => {}),
        GeneralService.get(`/trackers/select/volt`)
          .then((res) => {
            this.voltSelectOptions = Object.values(res.data.data);
          })
          .catch((e) => {}),
      ]).then(() => {
        GeneralService.get(
          `/trackers/table/${this.computedCurrentTabForPath}`,
          {
            params: {
              ...this.paginationFinesStateParams,
              limit: this.limitPaginationValue,
              page: page,
              ...(this.filter.length && { where: JSON.stringify(this.filter) }),
            },
          }
        )
          .then((data) => {
            if (this.computedCurrentTabForPath == "active") {
              this.isShowBanner = !data.data.data.rows?.length;
            }
            this.dataTable = data.data.data.rows;
            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
      console.log(this.filter);
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {},
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    editTrackerData() {
      return [
        {
          title: this.dataLang["tracker_text35"],
          value: this.dataLang[this.dataForModal.gps_statuses__name],
        },
        {
          title: this.dataLang["tracker_text36"],
          value: this.dataForModal.gps__tracker_id,
        },
        {
          title: this.dataLang["tracker_text37"],
          value: this.dataForModal.gps_tracker_templates__name,
        },
        {
          title: this.dataLang["tracker_text38"],
          value: this.dataForModal.gps__imei,
        },
        {
          title: this.dataLang["tracker_text26"],
          value: this.dataForModal.gps__gelios_unit_id,
        },
        {
          title: this.dataLang["tracker_text40"],
          value:
            this.dataLang[
              this.selectsDataForModal.typeVehicles.find(
                (value) =>
                  value.vehicle_types__id == this.dataForModal.vehicle_types__id
              )?.vehicle_types__code
            ],
        },
      ];
    },

    computedCurrentTabForPath() {
      if (this.activateTab == this.dataLang["tracker_text13"]) {
        return "active";
      } else {
        return "disabled";
      }
    },

    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "gps__tracker_id",
          key: "1636",
          title: this.dataLang["tracker_text23"],
          align: "center",
          width: "7%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps_tracker_templates__name",
          key: "15373",
          title: this.dataLang["tracker_text24"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps__volt",
          key: "volt",
          title: "Вольт",
          align: "center",
          width: "3%",
          ellipsis: { showTitle: false, lineClamp: 1 },
        },
        {
          field: "gps__imei",
          key: "1721",
          title: this.dataLang["tracker_text25"],
          align: "center",
          width: "12%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps__gelios_unit_id",
          key: "137246",
          title: this.dataLang["tracker_text26"],
          align: "center",
          width: "6%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "vehicle_types__code",
          key: "165315",
          title: this.dataLang["tracker_text27"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.vehicle_types__code]}</span>;
          },
        },
        {
          field: "vehicles__name",
          key: "1631411",
          title: this.dataLang["tracker_text28"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicles__name} {row.vehicles__gosnumber}
              </span>
            );
          },
        },
        {
          field: "gps__sim_phone",
          key: "163315",
          title: this.dataLang["tracker_text33"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps__sim_operator",
          key: "126341",
          title: this.dataLang["tracker_text43"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps__canpr",
          key: "163161",
          title: this.dataLang["tracker_text29"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "gps__odometr",
          key: "1631261",
          title: this.dataLang["tracker_text95"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
        {
          field: "...",
          key: "1631262",
          title: this.dataLang["tracker_text108"],
          align: "center",
          width: "8%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  align-items: center;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 75%;
}

.form-switch--custom input:checked + i::after {
  background-color: #cacaca;
}
</style>
